import { ProfessionalComponent } from './professional.component';
import { canDeactivateProfessionalGuard } from './professional.can-deactivate';
import { canDeactivateGuard } from 'directives/can-deactivate-guard';
import { professionalStepNotificationsResolver } from 'pages/professional/professional-step-notifications.resolver';
import { Routes } from '@angular/router';

export const ProfessionalRouting: Routes = [
  {
    path: '',
    component: ProfessionalComponent,
    canDeactivate: [canDeactivateProfessionalGuard, canDeactivateGuard],
    resolve: { messages: professionalStepNotificationsResolver },
    children: [
      {
        path: 'profile',
        loadChildren: () => import('app/features/profile-page/profile-page.module').then(m => m.ProfilePageModule),
      },
      {
        path: 'certifications',
        loadChildren: () =>
          import('app/pages/professional/certificates/certificates.module').then(m => m.CertificatesModule),
      },
      {
        path: 'workflows',
        loadChildren: () =>
          import('pages/professional/prof-workflow/professional-workflow.module').then(m => m.ProfWorkflowsModule),
      },
      {
        path: 'certifications/:cert_id/steps/:step_id',
        // TODO canActivate and redirectTo can't work at the same time
        // canActivate: [NumberParamGuard],
        data: { numberParams: ['cert_id', 'step_id'] },
        redirectTo: 'certifications/steps/:step_id',
      },
      {
        path: 'digital-wallet',
        loadChildren: () =>
          import('app/pages/professional/digital-wallet/digital-wallet.module').then(m => m.DigitalWalletModule),
        data: { title: 'Digital Wallet' },
      },
      {
        path: 'transcripts',
        loadChildren: () => import('app/features/transcript/transcript.module').then(m => m.TranscriptModule),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/professional/certifications',
      },
    ],
  },
];
